<div class="container">
  @if (appointment?.id) {
  <lib-small-aside-layout [hideAsideOnBreakpoint]="true" [rightAside]="true">
    <ng-container content-container>
      <lib-calendar-appointment-details-card
        [mode]="mode"
        [calendarAdditionalConfig]="calendarAdditionalConfig"
        [businessObject]="businessObject"
        [appointment]="appointment"
        [staff]="staff"
        [isLoading]="isLoading"
        (checkinClicked)="checkin()"
      ></lib-calendar-appointment-details-card>

      <ng-container *ngIf="shouldDisplayAdvancedInfo()">
        <lib-spacer [height]="10"></lib-spacer>
        <div class="description-wrapper">
          <div>
            {{
              'lib_calendar.appointment-details-page.text.creation_time'
                | translate
            }}: {{ appointment?.createdTimeAsDate | dateFormatter }}
            {{ appointment?.createdTimeAsDate | timeFormatter }}
          </div>
          <div>
            {{
              'lib_calendar.appointment-details-page.text.last_update'
                | translate
            }}: {{ appointment?.lastModifiedAsDate | dateFormatter }}
            {{ appointment?.lastModifiedAsDate | timeFormatter }}
          </div>
        </div>
      </ng-container>

      <ng-content select="[buttons]"></ng-content>

      <ng-container *ngIf="isAbleToCancelAppointment()">
        <lib-spacer></lib-spacer>
        <button
          mat-stroked-button
          class="full-width"
          color="warn"
          [disabled]="isLoading"
          (click)="cancelAppointment()"
        >
          {{
            'lib_calendar.appointment-details-page.buttons.cancel' | translate
          }}
        </button>
      </ng-container>
    </ng-container>

    <lib-base-card aside-container>
      <lib-calendar-appointment-chat-box
        [mode]="mode"
        [(appointment)]="appointment"
        [businessObject]="businessObject"
        [disable]="isEditActionForbiddenForStaffApp()"
      ></lib-calendar-appointment-chat-box>
    </lib-base-card>
  </lib-small-aside-layout>

  <div #fillRemainingHeightEl style="display: block"></div>

  <div class="chat-button">
    <button
      mat-fab
      color="primary"
      [disabled]="isLoading"
      (click)="openChatbox()"
    >
      <mat-icon>forum</mat-icon>
    </button>
  </div>
  } @else {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }
</div>
